import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "common-reply"
  }, [_c("div", {
    staticClass: "float-window",
    class: {
      "float-window-collapsed": _vm.isCollapsed
    },
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.changeCollapse(false);
      }
    }
  }, [_c("div", {
    staticClass: "float-header"
  }, [_c("div", {
    staticClass: "wlc-f-c"
  }, [_c("span", [_vm._v("常见回复")]), _c("el-select", {
    staticClass: "lang-select",
    attrs: {
      size: "mini",
      placeholder: "请选择"
    },
    on: {
      change: _vm.search
    },
    model: {
      value: _vm.form.language,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "language", $$v);
      },
      expression: "form.language"
    }
  }, _vm._l(_vm.langOpt, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _vm.isCollapsed ? _c("i", {
    staticClass: "fa wlc-pointer fa-expand"
  }) : _c("i", {
    staticClass: "fa wlc-pointer fa-compress",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.changeCollapse(true);
      }
    }
  })]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isCollapsed,
      expression: "!isCollapsed"
    }],
    staticClass: "float-content"
  }, [_c("div", {
    staticClass: "search-box wlc-f-c"
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入关键词",
      clearable: ""
    },
    on: {
      input: _vm.search
    },
    model: {
      value: _vm.form.keywords,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keywords", $$v);
      },
      expression: "form.keywords"
    }
  }), _c("i", {
    staticClass: "el-icon-search el-input__icon wlc-pointer",
    attrs: {
      slot: "suffix"
    },
    on: {
      click: _vm.search
    },
    slot: "suffix"
  })], 1), _c("div", {
    staticClass: "quick-tags"
  }, _vm._l(_vm.quickTags, function (tag, index) {
    return _c("span", {
      key: index,
      staticClass: "wlc-pointer tag",
      class: {
        "select-tag": tag.id === _vm.form.categoryId
      },
      on: {
        click: function click($event) {
          return _vm.handleTagClick(tag.id);
        }
      }
    }, [_vm._v(" " + _vm._s(tag.categoryZh) + " ")]);
  }), 0), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "search-result"
  }, [_vm._l(_vm.searchResults, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "result-item",
      on: {
        click: function click($event) {
          return _vm.selectAnswer(item);
        }
      }
    }, [_c("div", {
      staticClass: "result-title",
      domProps: {
        innerHTML: _vm._s(item.question)
      }
    }), _c("div", {
      staticClass: "result-content wlc-double-line",
      domProps: {
        innerHTML: _vm._s(item.content)
      }
    })]);
  }), _vm.searchResults.length ? _c("div", {
    staticClass: "no-more"
  }, [_vm._v(" 没有更多了 ")]) : _c("el-empty", {
    attrs: {
      "image-size": 70,
      description: "暂无数据"
    }
  })], 2)])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };